const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows phone/i.test(userAgent)) return "Windows Phone"

    if (/Android/i.test(userAgent)) return "Android"

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return "iOS"

    return "desktop"
}

export function QrcodeStores() {

    window.onload = () => {
        if (getMobileOperatingSystem() === "Android") return window.location.href = "https://app.appsflyer.com/com.icappsellers?pid=site&c=confirmação_agendamento&af_channel=QR_code"

        if (getMobileOperatingSystem() === "iOS") return window.location.href = "https://app.appsflyer.com/id1585861625?pid=site&c=confirmação_agendamento&af_channel=QR_code"

        return window.location.href = "/vistoria-not-found/"
    }
}
export function WppStores() {

    window.onload = () => {
        if (getMobileOperatingSystem() === "Android") return window.location.href = "https://app.appsflyer.com/com.icappsellers?pid=whatsapp&c=boas_vindas&af_channel=WPP"

        if (getMobileOperatingSystem() === "iOS") return window.location.href = "https://app.appsflyer.com/id1585861625?pid=whatsapp&c=boas_vindas&af_channel=WPP"

        return window.location.href = "/vistoria-not-found/"
    }
}

export function WppConfirmationStores() {

    window.onload = () => {
        if (getMobileOperatingSystem() === "Android") return window.location.href = "https://app.appsflyer.com/com.icappsellers?pid=whatsapp&c=pos_confirmacao&af_channel=WPP"

        if (getMobileOperatingSystem() === "iOS") return window.location.href = "https://app.appsflyer.com/id1585861625?pid=whatsapp&c=pos_confirmacao&af_channel=WPP"

        return window.location.href = "/vistoria-not-found/"
    }
}